/**
 * Shared display helpers for converting form-field keys into human labels.
 * Lifted out of DataCorrectionPage so the new ProfilePage Review step and
 * the legacy correction page render identically.
 */

/**
 * Humanizes a camelCase or snake_case key into a display label.
 *
 * @param key - The form data key to humanize (e.g. "annualIncome")
 * @returns string The humanized label (e.g. "Annual Income")
 */
export function humanizeKey(key: string): string {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase())
    .trim()
}
